import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircleQuestion } from "lucide-react";
import { api, photoUrl } from "@/lib/api";
import { errorMessage } from "@/lib/billing";

function QuestionRow({ q, onDone }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post(`/drafts/${q.id}/answer`, { text }); toast.success(`Answer sent to ${q.question.by.name}`); onDone(); }
    catch (err) { toast.error(errorMessage(err, "Couldn't send")); setBusy(false); }
  };
  return (
    <li className="flex gap-3 border-t border-amber-200 py-2.5" data-testid={`owner-question-${q.id}`}>
      <div className="h-12 w-12 shrink-0 overflow-hidden rounded-md bg-amber-100">{q.photos?.[0] && <img src={photoUrl(q.photos[0].id, "thumb")} alt="" className="h-full w-full object-cover" />}</div>
      <form onSubmit={send} className="min-w-0 flex-1 space-y-1.5">
        <p className="truncate text-[11px] text-amber-800">{q.title || "Untitled"}</p>
        <p className="text-sm text-slate-900" data-testid={`owner-question-text-${q.id}`}><b>{q.question.by.name}:</b> {q.question.text}</p>
        <div className="flex gap-1.5">
          <input value={text} onChange={(e) => setText(e.target.value)} maxLength={500} required placeholder="Your answer" className="h-8 min-w-0 flex-1 rounded-md border border-amber-300 bg-white px-2 text-sm" data-testid={`owner-answer-input-${q.id}`} />
          <button type="submit" disabled={busy || !text.trim()} className="shrink-0 rounded-full bg-amber-500 px-3 text-xs font-semibold text-white disabled:opacity-60" data-testid={`owner-answer-send-${q.id}`}>Reply</button>
        </div>
      </form>
    </li>
  );
}

// Owner-only: questions from listers, answered right here on the phone.
export default function OwnerQuestions() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/questions").then(({ data }) => setRows(data.questions || [])).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 5 * 60000);
    return () => clearInterval(t);
  }, [load]);
  if (!rows.length) return null;
  return (
    <section className="mb-4 rounded-xl border border-amber-300 bg-amber-50 px-3 pt-2.5" data-testid="owner-questions">
      <p className="flex items-center gap-1.5 pb-2 text-xs font-semibold text-amber-900"><MessageCircleQuestion className="h-4 w-4" /> {rows.length} question{rows.length === 1 ? "" : "s"} from your lister</p>
      <ul>{rows.map((q) => <QuestionRow key={q.id} q={q} onDone={load} />)}</ul>
    </section>
  );
}
